/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EnrollmentStatusRow } from './EnrollmentStatusRow';
import {
    EnrollmentStatusRowFromJSON,
    EnrollmentStatusRowFromJSONTyped,
    EnrollmentStatusRowToJSON,
    EnrollmentStatusRowToJSONTyped,
} from './EnrollmentStatusRow';

/**
 * 
 * @export
 * @interface WidgetDataEnrollmentStatusBreakdownWidgetData
 */
export interface WidgetDataEnrollmentStatusBreakdownWidgetData {
    /**
     * 
     * @type {string}
     * @memberof WidgetDataEnrollmentStatusBreakdownWidgetData
     */
    $type?: WidgetDataEnrollmentStatusBreakdownWidgetDataTypeEnum;
    /**
     * 
     * @type {Array<EnrollmentStatusRow>}
     * @memberof WidgetDataEnrollmentStatusBreakdownWidgetData
     */
    items: Array<EnrollmentStatusRow>;
}


/**
 * @export
 */
export const WidgetDataEnrollmentStatusBreakdownWidgetDataTypeEnum = {
    EnrollmentStatus: 'enrollment-status'
} as const;
export type WidgetDataEnrollmentStatusBreakdownWidgetDataTypeEnum = typeof WidgetDataEnrollmentStatusBreakdownWidgetDataTypeEnum[keyof typeof WidgetDataEnrollmentStatusBreakdownWidgetDataTypeEnum];


/**
 * Check if a given object implements the WidgetDataEnrollmentStatusBreakdownWidgetData interface.
 */
export function instanceOfWidgetDataEnrollmentStatusBreakdownWidgetData(value: object): value is WidgetDataEnrollmentStatusBreakdownWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function WidgetDataEnrollmentStatusBreakdownWidgetDataFromJSON(json: any): WidgetDataEnrollmentStatusBreakdownWidgetData {
    return WidgetDataEnrollmentStatusBreakdownWidgetDataFromJSONTyped(json, false);
}

export function WidgetDataEnrollmentStatusBreakdownWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetDataEnrollmentStatusBreakdownWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        '$type': json['$type'] == null ? undefined : json['$type'],
        'items': ((json['items'] as Array<any>).map(EnrollmentStatusRowFromJSON)),
    };
}

export function WidgetDataEnrollmentStatusBreakdownWidgetDataToJSON(json: any): WidgetDataEnrollmentStatusBreakdownWidgetData {
    return WidgetDataEnrollmentStatusBreakdownWidgetDataToJSONTyped(json, false);
}

export function WidgetDataEnrollmentStatusBreakdownWidgetDataToJSONTyped(value?: WidgetDataEnrollmentStatusBreakdownWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '$type': value['$type'],
        'items': ((value['items'] as Array<any>).map(EnrollmentStatusRowToJSON)),
    };
}

